import React, { useState } from 'react';
import AccordionItem from './accordion-item';

const Accordion = ({items = []}) => {
  const [selected, setSelected] = useState(-1)

  const handleClick = (item) => {
    if(selected === item.id){
      setSelected(-1)
    } else {
      setSelected(item.id)
    }
  }

  return <div className="lg:-mt-10">
    {
      items.length > 0 &&
      items.map(item => (
        <AccordionItem
          key={item.id}
          data={item}
          isSelected={item.id === selected}
          onClick={() => handleClick(item)}
        />
      ))
    }
  </div>
}

export { Accordion }
